
import { Component, Input, OnInit, ViewChild, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { MatSelectChange } from '@angular/material/select';
import { DatePipe, formatDate } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';  // Necesario para utilizar paginator y filter
import { LiquidacionService } from 'src/app/pages/services/liquidaciones/liquidacion.service';
import { MatSort } from '@angular/material/sort';
import { LicenciasService } from 'src/app/pages/services/licencias/licencias.service';
import { GestorAsistenciaService } from 'src/app/pages/services/gestor-asistencia/gestor-asistencia.service';
import { AuthService } from 'src/app/pages/auth/auth.service';
import { DocumentosService } from 'src/app/pages/services/documentos.service';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { getRoleFromToken } from 'src/app/shared/components/helpers/role.helpers';


@Component({
  selector: 'app-listar-licencias',
  templateUrl: './listar-licencias.component.html',
  styleUrls: ['./listar-licencias.component.css'],
  providers: [DatePipe]
})
export class ListarLicenciasComponent implements OnInit {
  isAuditor = getRoleFromToken() === 'AUDITOR';
  @Input() idTrabajador: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private modalService: NgbModal,
    private trabajadoresService: TrabajadoresService,
    private liquidacionService: LiquidacionService,
    private alert: AlertHelper,
    private datePipe: DatePipe,
    private licenciasService: LicenciasService,
    private asistenciaService: GestorAsistenciaService,
    private auth: AuthService,
    private documentoService: DocumentosService,
  ) {
    this.uploader.onCompleteAll = () => {

      //console.log('se termino de enviar ');
    };

    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      let user = this.auth.ObtenerinfoToken();
      form.append('estado', this.tramite.estado);
      form.append('id', this.tramite.id);
      form.append('userAt', user.nombre);

    };
  }


  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }



  public uploader: FileUploader = new FileUploader({
    url: `${environment.API}/rrhh/licencias/comprobante`,
    itemAlias: 'licencia',

  });

  displayedColumns = [
    'Fecha_inicio',
    'Fecha_termino',
    'Motivo',
    'Estado',
    'UpdateAT',
    'Acciones'
  ];

  hasBaseDropZoneOver: boolean;
  hasAnotherDropZoneOver: boolean;
  opciones = ['TRAMITADA', 'DENUNCIADA'];

  tramite = {
    estado: '',
    id: 0,
  }
  RutTrabajador: any;
  dataSource = new MatTableDataSource();
  liquidaciones: any;
  info_documento: any;
  loading: boolean = false;
  loadingData: boolean = false;

  calendario: any = {
    motivo: "",
    id: 0,
    start: "",
    end: "",
    trabajador: 0,
    dsueldo: "",
    dbono: ""
  };


  applyFilter(event: Event) {
    //Funcion para filtar cualquier columna por el texto buscado
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  // 🚀 Inicializa el componente cargando las licencias del trabajador ✨
  ngOnInit(): void {
    // console.log("Buscando licencias de RUT: "+this.rut);
    this.licenciasService.traerPorIdTrabajador(this.idTrabajador).subscribe(
      (res) => {
        // console.log(res.data[0].lenght);  // undefined
        this.liquidaciones = res.data;
        this.dataSource = new MatTableDataSource(this.liquidaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        //console.table(this.liquidaciones);
      }
    );

    this.traerLicencias();
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      let result = JSON.parse(response);
      //console.log(result);
      //response viene directo del backend
      if (result.success == true) {
        //console.log("el archivo se guardo con el nombre ", result.nombre);
        //console.log("El Comprobante Se subio Correctamente")
        Swal.fire({
          icon: 'success',
          title: 'Exito',
          text: result.msg,
        });
        //console.log(this.tramite.estado);
        if (this.tramite.estado === "TRAMITADA") {
          //console.log("Iniciando proceso de inasistencia");
          this.calendario.trabajador = this.idTrabajador;
          this.calendario.motivo = "LICENCIA";
          this.calendario.razon = 1;
          this.calendario.dsueldo = "SI";
          this.calendario.dbono = "SI";
          //console.log(this.calendario);

          this.asistenciaService.crearRegistroCalendario(this.calendario).subscribe((res: any) => {
            if (res.success == true) {
              //console.log("INASISTENCIA CREADA CORRECTAMENTE");

            } else {
              this.alert.error_small(res.msg!)
            }
          })

        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al subir archivo',
          text: 'se genero un error al subir archivo',

        })

      }
    }


  }

  // 🚀 Obtiene las licencias del trabajador y las muestra en la tabla ✨
  traerLicencias() {
    this.loadingData = true;
    this.licenciasService.traerPorIdTrabajador(this.idTrabajador).subscribe(
      (res) => {
        // console.log(res.data[0].lenght);  // undefined
        this.liquidaciones = res.data;
        this.dataSource = new MatTableDataSource(this.liquidaciones);
        this.dataSource = new MatTableDataSource(this.liquidaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        //console.table(this.liquidaciones);
        this.loadingData = false;
      },
      (error) => {
        console.error("Error al obtener licencias:", error);
        this.loadingData = false;
      }
    );
  }


  Descargar(id: any) {
    this.licenciasService.traerArchivoLicencia(id).subscribe((res) => {
      if (res.success) {
        this.info_documento = res.data[0];
        window.open(`${environment.API}/licencias/` + this.info_documento.ruta);
      } else {
        this.alert.error_small("No se encontró el archivo");
      }
    });
  }

  // 🚀 Elimina una licencia y actualiza la lista ✨
  Borrar(id: number, estado: boolean) {
    if (!confirm('¿Seguro que desea eliminar la licencia?')) return;

    if (estado) {
      this.documentoService.eliminarDocumento(id, 'LICENCIA').subscribe((res: RequestResponse) => {
        this.licenciasService.eliminarLicencia(id).subscribe((res: RequestResponse) => {
          this.alert.success_small('Se elimino la licencia');
          this.traerLicencias();
        }, (error) => {
          this.alert.error_small('Hubo un error al eliminar la licencia.');
          console.error(error);
        });
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar el documento.');
        console.error(error);
      });
    } else {
      this.licenciasService.eliminarLicencia(id).subscribe((res: RequestResponse) => {
        this.alert.success_small('Se elimino la licencia');
        this.traerLicencias();
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar la licencia.');
        console.error(error);
      });
    }
  }

  // 🚀 Descarga el comprobante de tramitación de la licencia ✨
  DescargarComprobante(id: any) {
    this.licenciasService.TraerLicenciaPorId(id).subscribe((res) => {
      if (res.success) {
        this.info_documento = res.data;
        window.open(`${environment.API}/licencias/` + this.info_documento.nombreDoc);
      }

    });
  }

  DescargarDenuncia(id: any) {
    this.licenciasService.TraerLicenciaPorId(id).subscribe((res) => {
      if (res.success) {
        this.info_documento = res.data;
        window.open(`${environment.API}/licencias/` + this.info_documento.nombreDocDenuncia);
      }
    });
  }

  // 🚀 Maneja los cambios en la tabla y actualiza el datasource ✨
  ngOnChanges(changes: SimpleChanges) {
    if (changes.liquidaciones != undefined) {
      if (!changes.liquidaciones.firstChange) {
        this.dataSource = new MatTableDataSource(this.liquidaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
      if (changes.liquidaciones && !changes.liquidaciones.firstChange) {
        this.dataSource = new MatTableDataSource(this.liquidaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
  }

  open(content: any, id: any) {
    this.modalService.open(content, { size: 'lg' });
    //console.log("Subir comprobante a licencia id: "+id);
    this.limpiar();
    this.tramite.id = id;
    this.tramite.estado = "TRAMITADA";
    //console.log(id,this.tramite.estado);
    this.licenciasService.TraerLicenciaPorId(id).subscribe(
      (res) => {
        this.calendario.start = res.data.fechaInicio;
        this.calendario.end = res.data.fechaTermin
      }
    )
  }


  open2(content: any, id: any) {
    this.modalService.open(content, { size: 'lg' });
    this.limpiar();
    this.tramite.id = id;
    this.tramite.estado = "DENUNCIADA";

    this.licenciasService.TraerLicenciaPorId(id).subscribe(
      (res) => {
        this.calendario.start = res.data.fechaInicio;
        this.calendario.end = res.data.fechaTermino
      }
    );
  }

  // 🚀 Guarda el archivo subido y cierra el modal ✨
  guardar() {


    if (this.validar()) {

      this.uploader.uploadAll();
      //console.log(this.tramite);
      this.cerrarModal();


    }
    else {
      //console.log("Error al guardar");

    }
  }

  // 🚀 Cierra el modal ✨
  cerrarModal() {
    this.modalService.dismissAll();
  }

  // 🚀 Limpia el formulario de subida de archivos ✨
  limpiar() {
    this.tramite.estado = '';
  }
  // 🚀 Valida que se haya seleccionado un estado antes de guardar ✨
  validar(): boolean {

    if (
      this.tramite.estado.length > 0
    ) {
      return true;
    }
    else {
      if (this.tramite.estado.length > 0) {
        return true;
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Faltan datos',
          text: 'Faltan datos , favor revisar',

        });
        return false;
      }
    }
  }
}



